'use client'
import { addToCart } from "app/actions/cart.actions";
import { createCartAndSetCookie } from "components/cart/actions";
import { useCart } from "components/cart/cart-context";
import { Spinner } from "flowbite-react";
import { useRouter } from "next/navigation";
import { startTransition, useEffect, useState } from "react";
import { cn } from "utils/cn";
import { nameToSlug } from "utils/slug-name";
import { ConfirmModal } from "./empty-cart-modal";

export function AddToCartBundle({handle, isLink = false, classNames}: {handle: string, isLink?: boolean, classNames?: string}) {    
  const router = useRouter()
  const {cart} = useCart()
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
      setIsOpen(true);
  }; 
  useEffect(() => {
    if (!cart) {
      createCartAndSetCookie();
    }
  }, [cart]);

  const formatHandle = isLink ? nameToSlug(handle) : handle
  
  const addToCartTransition = async()=>{
    setLoading(true)
    startTransition(async() => {
      const {message : messageResponse} = await addToCart(formatHandle)
      setLoading(false)
      setMessage(messageResponse)
    })
  } 
  useEffect(() => {
      if (message === 'success') {
        router.push(`/shop/${formatHandle}/add-ons`)
        router.refresh()
        setIsOpen(false)
      }
  } ,[message])
  
  const hasItems = cart && cart.lines.length > 0 
  const buttonClasses = cn('px-6 flex items-center flex-nowrap bg-fp-green hover:bg-white hover:border-fp-green border-2 min-w-24 min-h-10 rounded-md text-white hover:text-fp-green mt-4 w-full justify-center p-4 font-bold', classNames)
  const linkClasses = cn('hover:text-fp-green', classNames)
  return (
       <>
          <ConfirmModal isOpen={isOpen} setIsOpen={setIsOpen} confirm={addToCartTransition} isPending={loading}/> 
          <button onClick={hasItems? openModal : addToCartTransition}  className={isLink ? linkClasses: buttonClasses}>
            {loading && !isLink? <Spinner aria-label="Large spinner" size="lg" />: isLink ? handle: 'Add to cart'}
          </button>
        </>
    );
  }